"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _luxon = require("luxon");

var _ = require(".");

var Practice =
/** @class */
function () {
  function Practice() {
    this.id = null;
    this.name = null;
    this.identifier = null;
    this.contactName = null;
    this.contactEmail = null;
    this.contactPhoneNumber = null;
    this.isSuspended = null;
    this.isDemo = null;
    this.sendResultsToOwner = null;
    this.createdAt = null;
    this.updatedAt = null;
    this.addressId = null;
    this.address = null;
    this.users = null;
    this.labTechs = null;
    this.veterinarians = null;
    this.instruments = null;
    this.treatments = null;
    this.tests = null;
    this.testCount = null;
    this.monthTestCount = null;
    this.rangeTestCount = null;
    this.isInternal = null;
    this.testTypesWithCounts = null;
    this.practiceInventoryTypes = null;
    this.pimsIntegrations = null;
    this.locationSourceId = null;
    this.isEllie = null;
    this.isWhitelabeled = null;
    this.showQueue = null;
  }

  Practice.thaw = function (practiceObj) {
    var _a, _b;

    if (practiceObj == null) return null;
    var practice = new Practice();

    if (practiceObj.id != null) {
      practice.setId(practiceObj.id);
    }

    if (practiceObj.name != null) {
      practice.setName(practiceObj.name);
    }

    if (practiceObj.identifier != null) {
      practice.setIdentifier(practiceObj.identifier);
    }

    if (practiceObj.contactName != null) {
      practice.setContactName(practiceObj.contactName);
    }

    if (practiceObj.contactEmail != null) {
      practice.setContactEmail(practiceObj.contactEmail);
    }

    if (practiceObj.contactPhoneNumber != null) {
      practice.setContactPhoneNumber(practiceObj.contactPhoneNumber);
    }

    if (practiceObj.isSuspended != null) {
      practice.setIsSuspended(practiceObj.isSuspended == null ? null : practiceObj.isSuspended ? true : false);
    }

    if (practiceObj.isDemo != null) {
      practice.setIsDemo(practiceObj.isDemo == null ? null : practiceObj.isDemo ? true : false);
    }

    if (practiceObj.sendResultsToOwner != null) {
      practice.setSendResultsToOwner(practiceObj.sendResultsToOwner == null ? null : practiceObj.sendResultsToOwner ? true : false);
    }

    if (practiceObj.createdAt != null) {
      practice.setCreatedAt((_a = _luxon.DateTime === null || _luxon.DateTime === void 0 ? void 0 : _luxon.DateTime.fromISO(practiceObj.createdAt)) !== null && _a !== void 0 ? _a : null);
    }

    if (practiceObj.updatedAt != null) {
      practice.setUpdatedAt((_b = _luxon.DateTime === null || _luxon.DateTime === void 0 ? void 0 : _luxon.DateTime.fromISO(practiceObj.updatedAt)) !== null && _b !== void 0 ? _b : null);
    }

    if (practiceObj.addressId != null) {
      practice.setAddressId(practiceObj.addressId);
    }

    if (practiceObj.address != null) {
      practice.setAddress(_.Address.thaw(practiceObj.address));
    }

    if (practiceObj.users != null) {
      practice.setUsers(_.User.thawList(practiceObj.users));
    }

    if (practiceObj.labTechs != null) {
      practice.setLabTechs(_.LabTech.thawList(practiceObj.labTechs));
    }

    if (practiceObj.veterinarians != null) {
      practice.setVeterinarians(_.Veterinarian.thawList(practiceObj.veterinarians));
    }

    if (practiceObj.instruments != null) {
      practice.setInstruments(_.Instrument.thawList(practiceObj.instruments));
    }

    if (practiceObj.treatments != null) {
      practice.setTreatments(_.Treatment.thawList(practiceObj.treatments));
    }

    if (practiceObj.tests != null) {
      practice.setTests(_.Test.thawList(practiceObj.tests));
    }

    if (practiceObj.testCount != null) {
      practice.setTestCount(practiceObj.testCount);
    }

    if (practiceObj.monthTestCount != null) {
      practice.setMonthTestCount(practiceObj.monthTestCount);
    }

    if (practiceObj.rangeTestCount != null) {
      practice.setRangeTestCount(practiceObj.rangeTestCount);
    }

    if (practiceObj.isInternal != null) {
      practice.setIsInternal(practiceObj.isInternal == null ? null : practiceObj.isInternal ? true : false);
    }

    if (practiceObj.testTypesWithCounts != null) {
      practice.setTestTypesWithCounts(_.TestType.thawList(practiceObj.testTypesWithCounts));
    }

    if (practiceObj.practiceInventoryTypes != null) {
      practice.setPracticeInventoryTypes(_.PracticeInventoryType.thawList(practiceObj.practiceInventoryTypes));
    }

    if (practiceObj.pimsIntegrations != null) {
      practice.setPimsIntegrations(practiceObj.pimsIntegrations);
    }

    if (practiceObj.locationSourceId != null) {
      practice.setLocationSourceId(practiceObj.locationSourceId);
    }

    if (practiceObj.isEllie != null) {
      practice.setIsEllie(practiceObj.isEllie == null ? null : practiceObj.isEllie ? true : false);
    }

    if (practiceObj.isWhitelabeled != null) {
      practice.setIsWhitelabeled(practiceObj.isWhitelabeled == null ? null : practiceObj.isWhitelabeled ? true : false);
    }

    if (practiceObj.showQueue != null) {
      practice.setShowQueue(practiceObj.showQueue == null ? null : practiceObj.showQueue ? true : false);
    }

    return practice;
  };

  Practice.thawList = function (practiceObjList) {
    if (practiceObjList == null) {
      return [];
    }

    var practices = [];

    for (var i = 0; i < practiceObjList.length; i++) {
      practices.push(Practice.thaw(practiceObjList[i]));
    }

    return practices;
  };

  Practice.freeze = function (practice) {
    var _a, _b, _c, _d;

    if (practice == null) {
      return null;
    }

    var practiceObj = {};

    if (practice.getId() != null) {
      practiceObj.id = practice.getId();
    }

    if (practice.getName() != null) {
      practiceObj.name = practice.getName();
    }

    if (practice.getIdentifier() != null) {
      practiceObj.identifier = practice.getIdentifier();
    }

    if (practice.getContactName() != null) {
      practiceObj.contactName = practice.getContactName();
    }

    if (practice.getContactEmail() != null) {
      practiceObj.contactEmail = practice.getContactEmail();
    }

    if (practice.getContactPhoneNumber() != null) {
      practiceObj.contactPhoneNumber = practice.getContactPhoneNumber();
    }

    if (practice.getIsSuspended() != null) {
      practiceObj.isSuspended = practice.getIsSuspended() == null ? null : practice.getIsSuspended() ? 1 : 0;
    }

    if (practice.getIsDemo() != null) {
      practiceObj.isDemo = practice.getIsDemo() == null ? null : practice.getIsDemo() ? 1 : 0;
    }

    if (practice.getSendResultsToOwner() != null) {
      practiceObj.sendResultsToOwner = practice.getSendResultsToOwner() == null ? null : practice.getSendResultsToOwner() ? 1 : 0;
    }

    if (practice.getCreatedAt() != null) {
      practiceObj.createdAt = (_b = (_a = practice.getCreatedAt()) === null || _a === void 0 ? void 0 : _a.toISO()) !== null && _b !== void 0 ? _b : null;
    }

    if (practice.getUpdatedAt() != null) {
      practiceObj.updatedAt = (_d = (_c = practice.getUpdatedAt()) === null || _c === void 0 ? void 0 : _c.toISO()) !== null && _d !== void 0 ? _d : null;
    }

    if (practice.getAddressId() != null) {
      practiceObj.addressId = practice.getAddressId();
    }

    if (practice.getAddress() != null) {
      practiceObj.address = _.Address.freeze(practice.getAddress());
    }

    if (practice.getUsers() != null) {
      practiceObj.users = _.User.freezeList(practice.getUsers());
    }

    if (practice.getLabTechs() != null) {
      practiceObj.labTechs = _.LabTech.freezeList(practice.getLabTechs());
    }

    if (practice.getVeterinarians() != null) {
      practiceObj.veterinarians = _.Veterinarian.freezeList(practice.getVeterinarians());
    }

    if (practice.getInstruments() != null) {
      practiceObj.instruments = _.Instrument.freezeList(practice.getInstruments());
    }

    if (practice.getTreatments() != null) {
      practiceObj.treatments = _.Treatment.freezeList(practice.getTreatments());
    }

    if (practice.getTests() != null) {
      practiceObj.tests = _.Test.freezeList(practice.getTests());
    }

    if (practice.getTestCount() != null) {
      practiceObj.testCount = practice.getTestCount();
    }

    if (practice.getMonthTestCount() != null) {
      practiceObj.monthTestCount = practice.getMonthTestCount();
    }

    if (practice.getRangeTestCount() != null) {
      practiceObj.rangeTestCount = practice.getRangeTestCount();
    }

    if (practice.getIsInternal() != null) {
      practiceObj.isInternal = practice.getIsInternal() == null ? null : practice.getIsInternal() ? 1 : 0;
    }

    if (practice.getTestTypesWithCounts() != null) {
      practiceObj.testTypesWithCounts = _.TestType.freezeList(practice.getTestTypesWithCounts());
    }

    if (practice.getPracticeInventoryTypes() != null) {
      practiceObj.practiceInventoryTypes = _.PracticeInventoryType.freezeList(practice.getPracticeInventoryTypes());
    }

    if (practice.getPimsIntegrations() != null) {
      practiceObj.pimsIntegrations = practice.getPimsIntegrations();
    }

    if (practice.getLocationSourceId() != null) {
      practiceObj.locationSourceId = practice.getLocationSourceId();
    }

    if (practice.getIsEllie() != null) {
      practiceObj.isEllie = practice.getIsEllie() == null ? null : practice.getIsEllie() ? 1 : 0;
    }

    if (practice.getIsWhitelabeled() != null) {
      practiceObj.isWhitelabeled = practice.getIsWhitelabeled() == null ? null : practice.getIsWhitelabeled() ? 1 : 0;
    }

    if (practice.getShowQueue() != null) {
      practiceObj.showQueue = practice.getShowQueue() == null ? null : practice.getShowQueue() ? 1 : 0;
    }

    return practiceObj;
  };

  Practice.freezeList = function (practices) {
    if (practices == null) {
      return [];
    }

    var practiceObjList = [];

    for (var i = 0; i < practices.length; i++) {
      practiceObjList.push(Practice.freeze(practices[i]));
    }

    return practiceObjList;
  };
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  Practice.prototype.setId = function (id) {
    this.id = id;
  };

  Practice.prototype.setName = function (name) {
    this.name = name;
  };

  Practice.prototype.setIdentifier = function (identifier) {
    this.identifier = identifier;
  };

  Practice.prototype.setContactName = function (contactName) {
    this.contactName = contactName;
  };

  Practice.prototype.setContactEmail = function (contactEmail) {
    this.contactEmail = contactEmail;
  };

  Practice.prototype.setContactPhoneNumber = function (contactPhoneNumber) {
    this.contactPhoneNumber = contactPhoneNumber;
  };

  Practice.prototype.setIsSuspended = function (isSuspended) {
    this.isSuspended = isSuspended;
  };

  Practice.prototype.setIsDemo = function (isDemo) {
    this.isDemo = isDemo;
  };

  Practice.prototype.setSendResultsToOwner = function (sendResultsToOwner) {
    this.sendResultsToOwner = sendResultsToOwner;
  };

  Practice.prototype.setCreatedAt = function (createdAt) {
    this.createdAt = createdAt;
  };

  Practice.prototype.setUpdatedAt = function (updatedAt) {
    this.updatedAt = updatedAt;
  };

  Practice.prototype.setAddressId = function (addressId) {
    this.addressId = addressId;
  };

  Practice.prototype.setAddress = function (address) {
    this.address = address;
  };

  Practice.prototype.setUsers = function (users) {
    this.users = users;
  };

  Practice.prototype.setLabTechs = function (labTechs) {
    this.labTechs = labTechs;
  };

  Practice.prototype.setVeterinarians = function (veterinarians) {
    this.veterinarians = veterinarians;
  };

  Practice.prototype.setInstruments = function (instruments) {
    this.instruments = instruments;
  };

  Practice.prototype.setTreatments = function (treatments) {
    this.treatments = treatments;
  };

  Practice.prototype.setTests = function (tests) {
    this.tests = tests;
  };

  Practice.prototype.setTestCount = function (testCount) {
    this.testCount = testCount;
  };

  Practice.prototype.setMonthTestCount = function (monthTestCount) {
    this.monthTestCount = monthTestCount;
  };

  Practice.prototype.setRangeTestCount = function (rangeTestCount) {
    this.rangeTestCount = rangeTestCount;
  };

  Practice.prototype.setIsInternal = function (isInternal) {
    this.isInternal = isInternal;
  };

  Practice.prototype.setTestTypesWithCounts = function (testTypesWithCounts) {
    this.testTypesWithCounts = testTypesWithCounts;
  };

  Practice.prototype.setPracticeInventoryTypes = function (practiceInventoryTypes) {
    this.practiceInventoryTypes = practiceInventoryTypes;
  };

  Practice.prototype.setPimsIntegrations = function (pimsIntegrations) {
    this.pimsIntegrations = pimsIntegrations;
  };

  Practice.prototype.setLocationSourceId = function (locationSourceId) {
    this.locationSourceId = locationSourceId;
  };

  Practice.prototype.setIsEllie = function (isEllie) {
    this.isEllie = isEllie;
  };

  Practice.prototype.setIsWhitelabeled = function (isWhitelabeled) {
    this.isWhitelabeled = isWhitelabeled;
  };

  Practice.prototype.setShowQueue = function (showQueue) {
    this.showQueue = showQueue;
  };
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  Practice.prototype.getId = function () {
    return this.id;
  };

  Practice.prototype.getName = function () {
    return this.name;
  };

  Practice.prototype.getIdentifier = function () {
    return this.identifier;
  };

  Practice.prototype.getContactName = function () {
    return this.contactName;
  };

  Practice.prototype.getContactEmail = function () {
    return this.contactEmail;
  };

  Practice.prototype.getContactPhoneNumber = function () {
    return this.contactPhoneNumber;
  };

  Practice.prototype.getIsSuspended = function () {
    return this.isSuspended;
  };

  Practice.prototype.getIsDemo = function () {
    return this.isDemo;
  };

  Practice.prototype.getSendResultsToOwner = function () {
    return this.sendResultsToOwner;
  };

  Practice.prototype.getCreatedAt = function () {
    return this.createdAt;
  };

  Practice.prototype.getUpdatedAt = function () {
    return this.updatedAt;
  };

  Practice.prototype.getAddressId = function () {
    return this.addressId;
  };

  Practice.prototype.getAddress = function () {
    return this.address;
  };

  Practice.prototype.getUsers = function () {
    return this.users;
  };

  Practice.prototype.getLabTechs = function () {
    return this.labTechs;
  };

  Practice.prototype.getVeterinarians = function () {
    return this.veterinarians;
  };

  Practice.prototype.getInstruments = function () {
    return this.instruments;
  };

  Practice.prototype.getTreatments = function () {
    return this.treatments;
  };

  Practice.prototype.getTests = function () {
    return this.tests;
  };

  Practice.prototype.getTestCount = function () {
    return this.testCount;
  };

  Practice.prototype.getMonthTestCount = function () {
    return this.monthTestCount;
  };

  Practice.prototype.getRangeTestCount = function () {
    return this.rangeTestCount;
  };

  Practice.prototype.getIsInternal = function () {
    return this.isInternal;
  };

  Practice.prototype.getTestTypesWithCounts = function () {
    return this.testTypesWithCounts;
  };

  Practice.prototype.getPracticeInventoryTypes = function () {
    return this.practiceInventoryTypes;
  };

  Practice.prototype.getPimsIntegrations = function () {
    return this.pimsIntegrations;
  };

  Practice.prototype.getLocationSourceId = function () {
    return this.locationSourceId;
  };

  Practice.prototype.getIsEllie = function () {
    return this.isEllie;
  };

  Practice.prototype.getIsWhitelabeled = function () {
    return this.isWhitelabeled;
  };

  Practice.prototype.getShowQueue = function () {
    return this.showQueue;
  };
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


  Practice.prototype.getLogoUrl = function () {
    return this.isWhitelabeled ? "https://parasight-public-assets.s3.us-east-2.amazonaws.com/practice-logos/".concat(process.env.REACT_APP_NODE_ENV === 'production' ? 'prod' : 'dev', "/").concat(this.id, ".png") : null;
  };

  return Practice;
}();

var _default = Practice;
exports.default = _default;